

































































import { Component, Vue, Mixins, Prop, Watch } from 'vue-property-decorator';
import { State, Getter, Action, Mutation } from 'vuex-class';
import { IFloorplanButtonWithRelay, IFloorplanButton } from '@/store/views/floorplanView/types';
import DraggableMixin from '@/mixins/DraggableMixin';
import RelayMixin from '@/mixins/RelayMixin';
import IconPicker from '@/components/IconPicker.vue';
import ColorPicker from '@/components/ColorPicker.vue';
import _ from 'lodash';
import { IButtonsButton } from '../store/views/buttonsView/types';
import { IRelay } from '@/store/views/relaysView/types';

@Component({
    components: {
        IconPicker,
        ColorPicker,
    },
})
export default class FloorplanButton extends Mixins(DraggableMixin, RelayMixin) {

    @Prop({required: true})
    public deviceNumber: string;

    @Prop({required: true})
    public button: IFloorplanButtonWithRelay;

    @Prop({required: true})
    public index: number;

    @Prop({required: true})
    public selected: boolean;

    public someUniqueId: string = Math.random().toString();

    public editButton: IFloorplanButton | null = null;


    @Mutation('floorplanView/setButton')
    private viewSetButton?: (args: {deviceNumber: string, buttonIndex: number, button: IFloorplanButton | null})
        => void;

    @Getter('relaysView/relays')
    private getRelays: (deviceNumber: string) => IRelay[];

    public get relays(): IRelay[] {
        return this.getRelays(this.deviceNumber);
    }

    public get classes(): { [key: string]: boolean } {
        const result: { [key: string]: boolean } = {};
        if (this.button && this.button.button) {
            result[this.button.button.icon] = true;
        }
        if (this.isEditing) {
            result.edit = true;
            if (this.selected) {
                result.selected = true;
            }
        }
        if (this.button.button.size) {
            result[this.button.button.size] = true;
        }
        return result;
    }
    public get styles(): { [key: string]: string } {
        const result: { [key: string]: string } = {};
        if (this.button && this.button.button) {
            result.color = this.color;
        }
        return result;
    }

    public get color(): string {
        if (this.canMove || !this.button) {
            return 'white';
        }

        if (this.relayState.isLoading) {
            return 'yellow';
        }
        return this.relayState.isOn
            ? this.button.button.colorOn
            : this.button.button.colorOff;
    }

    public created() {
        if (this.deviceNumber && this.button) {
            this.setRelayInfo(this.deviceNumber, this.button.relay);
        }
    }

    public openEdit() {
        Vue.set(this, 'editButton', _.cloneDeep(this.button.button));
        (this.$refs[this.someUniqueId] as any).show();
    }

    public save() {
        if (this.viewSetButton) {
            this.viewSetButton({
                deviceNumber: this.deviceNumber,
                buttonIndex: this.index,
                button: this.editButton,
            });
        }
    }

    public deleteButton() {
        // setting editButton = null, will cause hide() to call save(), which whill remove it :)
        this.editButton = null;
        (this.$refs[this.someUniqueId] as any).hide();
        this.$emit('deleted');
    }
    //  public setIcon(newIcon: string) {
    //     if (this.deviceNumber && this.viewSetIcon && this.button
    //         && this.button.button.icon !== newIcon) {
    //         this.viewSetIcon({
    //             deviceNumber: this.deviceNumber,
    //             buttonNumber: this.number,
    //             icon: newIcon,
    //         });
    //     }
    // }

}
